import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBatchDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .0546265,
			y: .438126,
			width: 24,
			height: 24,
			rx: 12,
			fill: "#E7ECEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4186 6.07416L5.69069 18.8021",
			stroke: "#2B313A",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4186 18.8021L5.69069 6.07416",
			stroke: "#2B313A",
			strokeWidth: 1.5
		})
	]
});
export default SvgBatchDelete;
